
import { defineComponent, computed } from 'vue'

const CAPTIONS: {[key: string]: (scene: string) => string | null} = {
  't-shirt-united-athle-5001': (scene: string) => {
    switch (scene) {
      case 'front-wearing-man':
      case 'back-wearing-man':
        return '179cm / Lサイズ'
      case 'front-wearing-woman':
      case 'back-wearing-woman':
        return '162cm / Mサイズ'
      default:
        return null
    }
  },
  'long-sleeve-t-shirt-united-athle-5011': (scene: string) => {
    switch (scene) {
      case 'front-wearing-man':
      case 'back-wearing-man':
        return '178cm / XLサイズ'
      case 'front-wearing-woman':
      case 'back-wearing-woman':
        return '170cm / Lサイズ'
      default:
        return null
    }
  },
  'sweat-united-athle-5044': (scene: string) => {
    switch (scene) {
      case 'front-wearing-man':
      case 'back-wearing-man':
        return '178cm / XLサイズ'
      case 'front-wearing-woman':
      case 'back-wearing-woman':
        return '170cm / Lサイズ'
      default:
        return null
    }
  }
}

export default defineComponent({
  props: {
    itemName: {
      type: String,
      required: true
    },
    scene: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const caption = computed(() => {
      const fun = CAPTIONS[props.itemName]

      return fun ? fun(props.scene) : null
    })

    return { caption }
  }
})
